module.exports = __webpack_public_path__ + "img/git-commit.00746f95.svg";